import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-counter-card',
  templateUrl: './counter-card.component.html',
  styleUrls: ['./counter-card.component.scss'],
})
export class CounterCardComponent implements OnInit {
  @Input() title;
  @Input() count;

  constructor() { }

  ngOnInit(): void { }

  getCount(count) {
    if (count && !isNaN(count)) {
      if (count == -1) {
        return 'Undisclosed';
      } else if ((count == -2) || (count == -3) || (count == -4)) {
        return 'NA'
      } else {
        return count;
      }
    }
    return count;
  }
}
